export default import.meta.ROLLDOWN_FILE_URL_Wn8t9aBVxhW6paSmpVtb7g